import sendEventToUmami from '~/shared/trackEvent/sendEventToUmami';
import sendToGtm from '../gtm/sendToGtm';

const trackEvent = (event: Record<string, unknown>, name?: string) => {
  sendToGtm({ ...event, event: name });
  sendEventToUmami(event, name);
};
export default trackEvent;
